const getInitialsFromName = (name) => {
  if (!name) return "";
  const [first = "", second = ""] = `${name}`.trim().split(/\s+/);
  const firstInitial = first.charAt(0).toUpperCase();
  const secondInitial = second.charAt(0).toUpperCase();
  return `${firstInitial}${secondInitial}`.trim();
};

const getInitials = ({ firstName, lastName, fullName, fallback = "U" }) => {
  const firstInitial = firstName?.charAt(0)?.toUpperCase() || "";
  const secondInitial = lastName?.charAt(0)?.toUpperCase() || "";
  const byFirstAndLastName = `${firstInitial}${secondInitial}`.trim();

  if (byFirstAndLastName) return byFirstAndLastName;

  const byFullName = getInitialsFromName(fullName);
  if (byFullName) return byFullName;

  return fallback;
};

const UserInitialsAvatar = ({
  avatarUrl,
  firstName,
  lastName,
  fullName,
  fallback,
  className,
  alt = "user-avatar",
  style = {},
}) => {
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={alt}
        className={className}
        style={{ objectFit: "cover", borderRadius: "50%", ...style }}
      />
    );
  }

  return (
    <div
      className={className}
      aria-label={alt}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        textTransform: "uppercase",
        fontWeight: 600,
        color: "var(--theme-text, #171717)",
        backgroundColor: "var(--theme-border, #E9ECEF)",
        borderRadius: "50%",
        overflow: "hidden",
        ...style,
      }}
    >
      {getInitials({ firstName, lastName, fullName, fallback })}
    </div>
  );
};

export default UserInitialsAvatar;
